import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { t as theme } from './theme-0fe3bd9d.js';

var css_248z = ".spring-button{--tw-text-opacity:1;border-radius:30px;color:rgba(255,255,255,var(--tw-text-opacity));display:inline-block;font-size:20px;font-weight:600;line-height:26px;line-height:1;text-align:center}@media (min-width:1200px){.spring-button{max-width:290px}}.spring-button--default{max-width:100%;padding:20px 50px;width:270px}@media (min-width:1200px){.spring-button--default{width:290px}}.spring-button--small{font-size:13px;line-height:23px;padding:8px 25px;width:auto}@media (min-width:375px){.spring-button--small{font-size:16px;line-height:24px;min-width:200px;padding-bottom:10px;padding-top:10px}}@media (min-width:600px){.spring-button--small{padding-left:40px;padding-right:40px}}@media (min-width:1200px){.spring-button--small{width:auto}}.spring-button--full{width:100%}.spring-button--animated{transition-duration:.15s;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,-webkit-transform,-webkit-filter,-webkit-backdrop-filter;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-transform,-webkit-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.spring-button--animated:hover{--tw-translate-y:-5px;--tw-shadow:8px 8px 25px rgba(91,89,193,.16);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);-webkit-transform:var(--tw-transform);transform:var(--tw-transform)}.spring-button--outline{--tw-bg-opacity:1;--tw-text-opacity:1;-ms-flex-pack:center;background-color:rgba(255,255,255,var(--tw-bg-opacity));border-width:2px;color:rgba(36,38,33,var(--tw-text-opacity));display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:center;justify-content:center}.spring-button--outline.spring-button--loading{padding:6px}.spring-button--outline.spring-button--loading,.spring-button--outline:hover{--tw-text-opacity:1!important;color:rgba(255,255,255,var(--tw-text-opacity))!important}";
styleInject(css_248z);

// import AppSpinner from '@/components/common/AppSpinner'

var SpringButton = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', _vm._g({
      staticClass: "spring-button",
      class: [_vm.computedStyles, _vm.bgColorClass()],
      attrs: {
        "role": "button"
      }
    }, _vm.$listeners), [_vm.text && !_vm.loading ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.text))])]) : !_vm.loading ? _vm._t("default") : _vm._e(), _vm._v(" "), _vm.loading ? _c('div', [_vm._v("\n    loading...\n    ")]) : _vm._e()], 2);
  },
  staticRenderFns: [],
  name: 'SpringButton',
  components: {
    // AppSpinner
  },
  mixins: [theme],
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    animated: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      validator(value) {
        return ['default', 'small'].includes(value);
      },
      default: 'default',
      required: false
    },
    outline: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    computedStyles() {
      return [{
        'spring-button--animated': this.animated,
        'spring-button--outline': this.outline,
        'spring-button--loading': this.loading,
        'spring-button--full': this.fullWidth,
        '!text-blue-500 border-blue-500 hover:!bg-blue-500': this.outline && this.theme === 'blue',
        '!text-green-500 border-green-500 hover:!bg-green-500': this.outline && this.theme === 'green',
        '!text-pink-500 border-pink-500 hover:!bg-pink-500': this.outline && this.theme === 'pink',
        '!text-purple-500 border-purple-500 hover:!bg-purple-500': this.outline && this.theme === 'purple'
      }, `spring-button--${this.size}`];
    }
  }
};

export { SpringButton as S };
